import React from 'react'
import { node } from 'prop-types'
import { useLocation } from 'react-router-dom'
import { RoutesContext } from './context'
import { useRoutesNavigate } from './useRoutesNavigate'
import { URLS } from './urls'
import { getParam } from '~/utils/get-param'
import { useActions } from '~context'
import { dispatchEnableReviewEvent } from '~/services/analyticsEvents'

const getPathname = location => {
  let replacer = `/${URLS.BASE_URL}/`
  if (URLS.BASE_URL === '/') {
    replacer = '/'
  }
  return location.pathname.replace(replacer, '')
}

const RoutesNavigate = ({ children }) => {
  const context = useRoutesNavigate()
  const location = useLocation()
  const actions = useActions()

  React.useEffect(() => {
    context.setCurrent(getPathname(location))
  }, [location])

  React.useEffect(() => {
    const screenReview = getParam('screen-review', location?.search)

    if (screenReview) {
      dispatchEnableReviewEvent(screenReview)
      actions.context.setScreenReview(screenReview)
    }
  }, [location])

  React.useEffect(() => {
    const referrerValue = getParam('referrer', location?.search)

    if (referrerValue) {
      context.setReferrer(referrerValue)
    }
  }, [location])

  React.useEffect(() => {
    const tokenValue = getParam('token', location?.search)

    if (tokenValue) {
      actions.singleAuth.setToken(tokenValue)
    }
  }, [location])

  React.useEffect(() => {
    const nameValue = getParam('name', location?.search)

    if (nameValue) {
      actions.review.setName(nameValue)
    }
  }, [location])

  const setUsernameByPath = {
    [URLS.passwordless.identify.path()]: actions.passwordless.setUsername,
    [URLS.passwordless.review.path()]: phone => {
      actions.review.setPhone(phone.replace(/^\+?55/, ''))
    },
    [URLS.password.identify.path()]: actions.password.setUsername,
  }

  React.useEffect(() => {
    const username = getParam('username', location?.search)

    if (username) {
      const set = setUsernameByPath[getPathname(location)]

      set?.(username)
    }
  }, [location])

  return (
    <RoutesContext.Provider value={context}>{children}</RoutesContext.Provider>
  )
}

RoutesNavigate.propTypes = {
  children: node.isRequired,
}

export { RoutesNavigate }
